import { authClient, authServer } from '../../../constants/auth';

const responseFetchUserDetailsMapper = (payload) => ({
  [authClient.FIRMA_ADI]: payload[authServer.FIRMA_ADI],
  [authClient.KULLANICI_ADI]: payload[authServer.KULLANICI_ADI],
  [authClient.MUSTERI_ADI]: payload[authServer.MUSTERI_ADI],
});

export default responseFetchUserDetailsMapper;
